import React, { useState } from 'react';

import { Button } from '@eika/button';
import { ConfirmationDialog } from '@eika/confirmation-dialog';
import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';
import { Loader } from '@eika/loader';
import { ToggleSwitch } from '@eika/toggle-switch';

import { useEfakturaAgreement } from '../../fetchHooks/useEfaktura';
import useTranslation from '../../hooks/useTranslation';

import './EFakturaAgreement.scss';

const UpdateEFakturaAgreement = (): JSX.Element => {
    const translated = useTranslation();
    const [value, setValue] = useState(false);
    const {
        data: agreement,
        isLoading,
        enableAgreement,
        createAgreement,
        disableAgreement,
        error,
    } = useEfakturaAgreement(setValue);

    const [showDialog, setShowDialog] = useState(false);

    const onCancel = async () => {
        setShowDialog(false);
        setValue(!!agreement?.enabled);
    };

    const changeValue = (newValue: boolean, force = false) => {
        setValue(newValue);
        if (!agreement || !agreement.hasAgreement) {
            createAgreement();
            return;
        }
        if (newValue === agreement?.enabled) {
            return;
        }
        if (!newValue && !force) {
            setShowDialog(true);
            return;
        }
        setShowDialog(false);
        if (newValue) {
            enableAgreement();
            return;
        }
        disableAgreement();
    };

    return (
        <li className="efaktura-agreement-list efaktura-agreement">
            <div className="efaktura-agreement-list_button">
                <div className="efaktura-agreement__jtta">
                    <span className="efaktura-agreement__jtta-title">{translated.eFakturaAgreement.jttaTitle}</span>
                    {isLoading ? (
                        <Loader mini />
                    ) : (
                        <ToggleSwitch
                            checked={value}
                            onChange={changeValue}
                            ariaLabel={translated.eFakturaAgreement.jttaAriaLabel}
                        />
                    )}
                </div>
                <p className="efaktura-agreement__jtta-description">{translated.eFakturaAgreement.jttaDescription}</p>
                {error && (
                    <div className="efaktura-agreement__error-label">
                        <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={translated.eFakturaAgreement.errorLabel} />
                    </div>
                )}
                <ConfirmationDialog
                    title={translated.eFakturaAgreement.dialogTitle}
                    description={translated.eFakturaAgreement.dialogDescription}
                    className="efaktura-agreement__confirmation-dialog"
                    id="confirmation-dialog-efaktura-agreement"
                    blueBackground
                    headingLevel={3}
                    show={showDialog && !value}
                    onExitFocus={onCancel}
                    footer={
                        <>
                            <Button buttonType="link" onClick={onCancel}>
                                {translated.cancel}
                            </Button>
                            <Button size="small" onClick={() => changeValue(false, true)}>
                                {translated.eFakturaAgreement.dialogConfirmation}
                            </Button>
                        </>
                    }
                />
            </div>
        </li>
    );
};

export default UpdateEFakturaAgreement;
